/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useSelector } from "react-redux";
import Select from 'react-select';
import { getUserTypeScortsFilter, getUserTypeScortsFilterMany } from '../redux/FiltersSelector';
import { colourStylesSelect, themeSelect } from '../helpers';

interface Props {
  applyFilter: (data: any) => void;
  initialValues: Array<any>;
}

export const UserTypeEscortFilter: React.FC<Props> = ({applyFilter, initialValues}) => {
  const userTypeScortsChoices: Array<any> = useSelector(getUserTypeScortsFilter) as Array<any>;
  const initialUserTypesValues: Array<any> = useSelector(getUserTypeScortsFilterMany(initialValues)) as Array<any>;
  const [optionsSelect, setOptionsSelect] = React.useState(initialUserTypesValues)

  return (
    <div className='col-lg-4 py-4'>
      <h4>Tipo de escort</h4>
      <Select
        styles={colourStylesSelect}
        theme={themeSelect}
        options={userTypeScortsChoices}
        placeholder="Seleccionar escort"
        defaultValue={optionsSelect}
        value={optionsSelect}
        isClearable={true}
        isMulti={true}
        onChange={(option) => {
          let totalOptions = option.length
          if (totalOptions > 0 && option) {
            setOptionsSelect([...option]);
            // FILTRAR
            const userTypesToSend = option.map((item: any) => item.value)
            if (userTypesToSend) {
              applyFilter({userTypes: userTypesToSend})
            }
            
          } else {
            setOptionsSelect([]);
            applyFilter({userTypes: []})
          }
        }}
      />
    </div>
  )
}

export default UserTypeEscortFilter;
